const colors = {
  secondary: {
    main: '#616161',
    contrastText: '#fff',
  },
  quaternary: {
    main: '#ba000d',
    contrastText: '#fff',
  },
  tertiary50: '#fafafa',
  tertiary100: '#f5f5f5',
  tertiary200: '#eeeeee',
  tertiary300: '#e0e0e0',
  tertiary400: '#bdbdbd',
  tertiary500: '#9e9e9e',
  tertiary600: '#757575',
  tertiary700: '#616161',
  tertiary800: '#424242',
  tertiary900: '#212121',
  tertiaryA100: '#f5f5f5',
  tertiaryA200: '#eeeeee',
  tertiaryA400: '#bdbdbd',
  tertiaryA700: '#616161',
  white: '#fff',
};

export default colors;
